import { action } from 'typesafe-actions';
import { StoredRouteActionTypes } from './types';

export const setCurrentRouteAction = (currentRoute: string) =>
    action(StoredRouteActionTypes.SET_CURRENT_ROUTE, currentRoute);

export const setMenuCollapsedAction = (menuCollapsed: boolean) =>
    action(StoredRouteActionTypes.SET_MENU_COLLAPSE_STATE, menuCollapsed);
